import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";

const TableLogo = () => {
  const navigate = useNavigate();
  const [logos, setLogos] = useState([]);
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [deleteLogoId, setDeleteLogoId] = useState(null);

  useEffect(() => {
    const fetchLogoData = async () => {
      try {
        const response = await axios.get("/api_w/logo", {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        setLogos(response.data.data);
      } catch (error) {
        toast.error(
          "Error fetching logo data: " +
            (error.response.data?.message || error.message)
        );
      }
    };

    fetchLogoData();
  }, []);

  const handleEditClick = (id) => {
    navigate(`/admin/edit-logo/${id}`);
  };

  const handleDeleteClick = (id) => {
    setDeleteLogoId(id);
    setShowDeletePrompt(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`/api_w/logo/${deleteLogoId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      toast.success("Berhasil Hapus Logo");
      const response = await axios.get(`/api_w/logo`, {
        headers: {
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      setLogos(response.data.data);
    } catch (error) {
      toast.error(
        "Gagal Hapus Logo" + (error.response?.data?.message || error.message)
      );
    } finally {
      setShowDeletePrompt(false);
    }
  };

  const handleCancelDelete = () => {
    setShowDeletePrompt(false);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full bg-white">
        <thead className="bg-green-700 text-sm uppercase leading-normal text-white">
          <tr>
            <th className="py-3 px-6 text-center">No</th>
            <th className="py-3 px-6 text-center">Judul</th>
            <th className="py-3 px-6 text-center">Logo</th>
            <th className="py-3 px-6 text-center">Aksi</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {logos.map((logo, index) => (
            <tr
              key={logo.id}
              className="border-b border-gray-200 hover:bg-gray-100"
            >
              <td className="py-3 px-6 text-center">{index + 1}</td>
              <td className="py-3 px-6 text-center">{logo.title}</td>
              <td className="text-center">
                <div className="flex justify-center items-center">
                  <img src={logo.url} alt={logo.title} className="h-20 w-20" />
                </div>
              </td>
              <td className="py-3 px-6 text-center">
                <div className="item-center flex justify-center">
                  <button
                    className="mr-2 w-4 transform text-blue-400 hover:scale-110 hover:text-blue-600"
                    onClick={() => handleEditClick(logo.id)}
                  >
                    <FaEdit className="h-4 w-4" />
                  </button>
                  <button
                    className="mr-2 w-4 transform text-red-500 hover:scale-110 hover:text-red-600"
                    onClick={() => handleDeleteClick(logo.id)}
                  >
                    <FaTrash className="h-4 w-4" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showDeletePrompt && (
        <div className="bg-black fixed inset-0 flex items-center justify-center bg-opacity-50">
          <div className="rounded bg-white p-4 shadow-md">
            <h2 className="mb-4 text-lg font-semibold">
              Konfirmasi Hapus Logo
            </h2>
            <p className="mb-4">Apakah anda yakin akan menghapus logo ini?</p>
            <div className="flex justify-end gap-4">
              <button
                className="rounded bg-gray-500 py-2 px-4 text-white hover:bg-gray-700"
                onClick={handleCancelDelete}
              >
                Batal
              </button>
              <button
                onClick={handleConfirmDelete}
                className="rounded bg-red-500 py-2 px-4 text-white hover:bg-red-700"
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default TableLogo;
